import { Component } from "@angular/core";

@Component({
  templateUrl: './my-followers.component.html'
})
export class MyFollowersComponent {

  constructor() {
  }


}
